import React, { useEffect, useState } from "react";
import { Image, Spin, Typography, Modal, Tag, Input, Pagination } from "antd";
import "../styles/Dashboard.css";
import axios from "../axios";
import logo from "../SolitaryTL.png";
import crystal from "../imgs/Crystal.png";
import axe from "../imgs/Axe.png";
import nethpot from "../imgs/NethPot.png";
import pot from "../imgs/Pot.png";
import smp from "../imgs/SMP.png";
import sword from "../imgs/Sword.png";
import uhc from "../imgs/UHC.png";

const { Title } = Typography;
const { Search } = Input;

export default function Dashboard() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTierType, setSelectedTierType] = useState("crystal");
    const [tiersData, setTiersData] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalUser, setModalUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fetchedData, setFetchedData] = useState([]);

    const tierTypes = [
        "Overall",
        "crystal",
        "nethpot",
        "diapot",
        "smp",
        "sword",
        "axe-shield",
        "uhc",
    ];

    var tierPoints = [
        { tier: "HT1", points: 60 },
        { tier: "LT1", points: 45 },
        { tier: "HT2", points: 30 },
        { tier: "LT2", points: 20 },
        { tier: "HT3", points: 10 },
        { tier: "LT3", points: 6 },
        { tier: "HT4", points: 4 },
        { tier: "LT4", points: 3 },
        { tier: "HT5", points: 2 },
        { tier: "LT5", points: 1 },
    ];

    const tierColors = {
        LT1: "#4A90E2",
        LT2: "#4A90E2",
        LT3: "#4A90E2",
        LT4: "#4A90E2",
        LT5: "#4A90E2",
        HT1: "#6A5ACD",
        HT2: "#6A5ACD",
        HT3: "#6A5ACD",
        HT4: "#6A5ACD",
        HT5: "#6A5ACD",
        RLT1: "#D7942D",
        RLT2: "#D7942D",
        RHT1: "#D7942D",
        RHT2: "#D7942D",
    };

    const tierIcons = {
        crystal: <Image src={crystal} preview={false} />,
        nethpot: <Image src={nethpot} preview={false} />,
        diapot: <Image src={pot} preview={false} />,
        smp: <Image src={smp} preview={false} />,
        sword: <Image src={sword} preview={false} />,
        "axe-shield": <Image src={axe} preview={false} />,
        uhc: <Image src={uhc} preview={false} />,
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("/api/data");
                setFetchedData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const processFetchedData = () => {
            fetchedData.forEach((element) => {
                element.points = 0;
                JSON.parse(element.latestResults).forEach((result) => {
                    var points = tierPoints.find(
                        (tier) => tier.tier.toLowerCase() === result.result.toLowerCase()
                    ).points;
                    element.points += points;
                });
            });

            fetchedData.sort((a, b) => b.points - a.points);
            fetchedData.forEach((element, index) => {
                element.index = index + 1;
            });

            const groupedData = {};
            fetchedData.forEach((user) => {
                const results = JSON.parse(user.latestResults);
                results.forEach((result) => {
                    if (result.tierType === selectedTierType) {
                        if (!groupedData[result.result]) groupedData[result.result] = [];
                        groupedData[result.result].push(user);
                    }
                });
            });

            setTiersData(groupedData);
            setData(fetchedData);
        };

        processFetchedData();
    }, [selectedTierType, fetchedData]);

    const handleUserClick = (user) => {
        setModalUser(user);
        setIsModalVisible(true);
    };

    const handleSearch = (value) => {
        setSearchQuery(value);
    };

    const filteredData = data.filter((user) =>
        user.username?.toLowerCase().includes(searchQuery?.toLowerCase())
    );

    const getUserTiers = (username) => {
        const user = data.find((u) => u.username === username);
        if (!user) return [];
        const results = JSON.parse(user.latestResults);
        return results;
        // return results.map((result) => `${result.tierType}: ${result.result}`);
    };

    const paginatedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    return (
        <div className="dashboard-div">
            {loading ? (
                <Spin size="large" />
            ) : (
                <>
                    <div className="top-page">
                        <div className="dashboard-header">
                            <Image
                                src={logo}
                                className="dashboard-logo"
                                alt="Solitary Tiers Logo"
                                width={100}
                                preview={false}
                            />
                            <Title className="dashboard-title">Solitary Tiers</Title>
                        </div>
                        <div className="navbar">
                            {tierTypes.map((tierType) => (
                                <div
                                    key={tierType}
                                    className={`navbar-item ${selectedTierType === tierType ? "active" : ""
                                        }`}
                                    onClick={() => setSelectedTierType(tierType)}
                                >
                                    {tierType.charAt(0).toUpperCase() + tierType.slice(1)}
                                </div>
                            ))}
                        </div>
                        <Search
                            placeholder="Search users..."
                            allowClear
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{ width: 300, marginBottom: 20 }}
                        />
                    </div>

                    <div className="content">
                        {selectedTierType === "Overall" ? (
                            <div className="overall-leaderboard">
                                {paginatedData.map((user, index) => (
                                    <div
                                        key={index}
                                        className="leaderboard-entry"
                                        onClick={() => handleUserClick(user)}
                                    >
                                        <div className={`rank-badge rank-${data.findIndex(u => u.username === user.username) + 1}`}>
                                            {data.findIndex(u => u.username === user.username) + 1}.
                                        </div>

                                        <div className="player-avatar">
                                            <Image
                                                src={
                                                    user.avatarUrl ||
                                                    "https://i.pinimg.com/474x/54/f4/b5/54f4b55a59ff9ddf2a2655c7f35e4356.jpg"
                                                }
                                                className="player-avatar-img"
                                                preview={false}
                                            />
                                        </div>
                                        <div className="player-info">
                                            <div className="player-name">
                                                {user.username}
                                                <span className="region-tag" style={{ marginLeft: '8px' }}>
                                                    <Tag color={user.region === "NA" ? "red" : "green"}>
                                                        {user.region}
                                                    </Tag>
                                                </span>
                                            </div>
                                            <div className="player-role">
                                                {user.role} ({user.points} points)
                                            </div>
                                        </div>
                                        {user.retired ? (
                                            <Tag color="red">Retired</Tag>
                                        ) : (
                                            <></>
                                        )}
                                        <div className="player-tiers">
                                            {JSON.parse(user.latestResults)
                                                .sort((a, b) => {
                                                    const pointsA = tierPoints.find(tier => tier.tier.toLowerCase() === a.result.toLowerCase())?.points || 0;
                                                    const pointsB = tierPoints.find(tier => tier.tier.toLowerCase() === b.result.toLowerCase())?.points || 0;
                                                    return pointsB - pointsA;
                                                })
                                                .map((result, i) => {
                                                    const isRetired = result.retired && ["HT1", "HT2", "LT1", "LT2"].includes(result.result);
                                                    const displayResult = isRetired ? `R${result.result}` : result.result;

                                                    return (
                                                        <Tag
                                                            className="tier-tag"
                                                            key={i}
                                                            color={tierColors[displayResult] || tierColors[result.result]}
                                                        >
                                                            <div className="tier-icon">{tierIcons[result.tierType]}</div>
                                                            {displayResult}
                                                        </Tag>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                ))}
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={filteredData.length}
                                    onChange={(page, pageSize) => {
                                        setCurrentPage(page)
                                        setPageSize(pageSize)
                                    }}
                                    className="pagination-controls"
                                />
                            </div>
                        ) : (
                            <div className="tiers-grid">
                                {["1", "2", "3", "4", "5"].map((tierNumber) => (
                                    <div key={tierNumber} className="tier-row">
                                        <div className="tier-title">Tier {tierNumber}</div>
                                        <div className="tier-users">
                                            {["HT", "LT"].map((prefix) => {
                                                const tier = `${prefix}${tierNumber}`;
                                                if (!tiersData[tier] || tiersData[tier].length === 0) {
                                                    return null;
                                                }
                                                var user = tiersData[tier]
                                                    .filter((user) =>
                                                        user.username
                                                            ?.toLowerCase()
                                                            .includes(searchQuery?.toLowerCase())
                                                    )
                                                return user.map((user, index) => {
                                                    var json = JSON.parse(user.latestResults);
                                                    if (json.some(result => result.tierType === selectedTierType && result.retired)) return null;
                                                    else
                                                        return (
                                                            <div
                                                                key={index}
                                                                className="tier-user"
                                                                onClick={() => handleUserClick(user)}
                                                            >
                                                                <Tag color={tierColors[tier] || "#3b3b54"}>
                                                                    {tier}
                                                                </Tag>
                                                                <div>{user.username}</div>
                                                            </div>
                                                        )
                                                });
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </>
            )}
            {modalUser && (
                <Modal
                    title={modalUser.username}
                    open={isModalVisible}
                    onCancel={() => setIsModalVisible(false)}
                    footer={null}
                    className="player-modal"
                >
                    <div className="modal-content">
                        <img
                            src={
                                modalUser.avatarUrl ||
                                "https://i.pinimg.com/474x/54/f4/b5/54f4b55a59ff9ddf2a2655c7f35e4356.jpg"
                            }
                            alt={modalUser.username}
                            className="modal-avatar"
                        />
                        <div className="modal-info">
                            <p>
                                <strong>Username:</strong> {modalUser.username}
                            </p>
                            <p>
                                <strong>Discord ID:</strong> {modalUser.discordId}
                            </p>
                            <p>
                                <strong>Account Type:</strong> {modalUser.cracked === 0 ? "Cracked" : "Premium"}
                            </p>
                            <p>
                                <strong>Region:</strong> {modalUser.region}
                            </p>
                            <p>
                                <strong>Overall Rank:</strong> #{data.findIndex(u => u.username === modalUser.username) + 1}
                            </p>
                            <p>
                                <strong>Tiers:</strong>
                            </p>
                            <div className="player-tiers">
                                {getUserTiers(modalUser.username)
                                    .sort((a, b) => {
                                        const pointsA = tierPoints.find(tier => tier.tier.toLowerCase() === a.result.toLowerCase())?.points || 0;
                                        const pointsB = tierPoints.find(tier => tier.tier.toLowerCase() === b.result.toLowerCase())?.points || 0;
                                        return pointsB - pointsA;
                                    })
                                    .map((tier, index) => {
                                        // Add "R" if retired and in specific tiers
                                        const isRetired = tier.retired && ["HT1", "HT2", "LT1", "LT2"].includes(tier.result);
                                        const displayResult = isRetired ? `R${tier.result}` : tier.result;

                                        return (
                                            <Tag
                                                className="tier-tag"
                                                key={index}
                                                color={tierColors[displayResult] || tierColors[tier.result]} // Use retired color if applicable
                                            >
                                                <div className="tier-icon">{tierIcons[tier.tierType]}</div>
                                                {displayResult}
                                            </Tag>
                                        );
                                    })}



                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
}
